import {
  PaginationResultsVehicleAssignTableDataDto,
  PaginationResultsVehicleTableDataDto,
  VehicleRegistrationNumberDto,
  BulkDeleteVehicleRequest,
  BulkEditVehicleRequest,
  EditVehicleRequest,
  GetVehicleResponse,
  AddVehicleRequest,
  ImportSummaryDto,
  SearchRequest,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';
import qs from 'qs';

export async function getAllVehicles(): Promise<VehicleRegistrationNumberDto[]> {
  return httpClient.get('vehicles/registration-numbers').json();
}

export async function getPaginatedVehicles(
  request: SearchRequest,
): Promise<PaginationResultsVehicleTableDataDto> {
  return httpClient
    .get(`vehicles`, {
      searchParams: qs.stringify(request, { allowDots: true }),
    })
    .json();
}

export async function getVehicle(id: string): Promise<GetVehicleResponse> {
  return httpClient.get(`vehicles/${id}`).json();
}

export async function createVehicle(vehicle: AddVehicleRequest) {
  return httpClient
    .post(`vehicles`, {
      json: vehicle,
    })
    .json();
}

export async function updateVehicle({ id, data }: { data: EditVehicleRequest; id: string }) {
  return httpClient.put(`vehicles/${id}`, { json: data }).json();
}

export async function deleteVehicle(id: string) {
  return httpClient.delete(`vehicles/${id}`).json();
}

export async function bulkEditVehicles({
  costCenters,
  ids,
}: BulkEditVehicleRequest): Promise<void> {
  return httpClient.put('vehicles/bulk-edit', { json: { ids, costCenters } }).json();
}

export async function bulkDeleteVehicles({ ids }: BulkDeleteVehicleRequest): Promise<void> {
  return httpClient.put(`vehicles/bulk-delete`, { json: { ids } }).json();
}

export async function getVehicleImportSummary(file: File): Promise<ImportSummaryDto> {
  const formData = new FormData();
  formData.append('file', file);

  return httpClient.post('vehicles/import-summary', { body: formData, timeout: 180000 }).json();
}

export async function getVehicleImportErrorFile(): Promise<Blob> {
  return httpClient.get('vehicles/import-errors', { timeout: 180000 }).blob();
}

export async function saveVehiclesImport(): Promise<void> {
  return httpClient.post(`vehicles/import-bulk`, { timeout: 180000 }).json();
}

export async function getVehicleFiltersServices(): Promise<string[]> {
  return httpClient.get(`vehicles/filter/services`).json();
}

export async function getVehicleFiltersCountries(): Promise<string[]> {
  return httpClient.get(`vehicles/filter/countries`).json();
}

export async function getVehicleFiltersCategories(): Promise<string[]> {
  return httpClient.get(`vehicles/filter/categories`).json();
}

export async function getAssignVehicles(
  request: { ids: string[] } & SearchRequest,
): Promise<PaginationResultsVehicleAssignTableDataDto> {
  return await httpClient
    .post('vehicles/assigned', {
      json: request,
    })
    .json();
}

export async function getVehicles(
  request: SearchRequest,
): Promise<PaginationResultsVehicleAssignTableDataDto> {
  return await httpClient
    .get('vehicles/assign', {
      searchParams: qs.stringify(request, { allowDots: true }),
    })
    .json();
}
